"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authSubscriptionContract = void 0;
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const draw_1 = require("../draw/draw");
const models_1 = require("../draw/drawOrder/models");
const models_2 = require("../order/models");
const models_3 = require("../promo/models");
const utils_1 = require("../utils");
const models_4 = require("./models");
const c = (0, core_1.initContract)();
exports.authSubscriptionContract = c.router({
    createSubscription: {
        method: 'POST',
        path: '/',
        responses: {
            200: zod_1.z.object({
                orderId: zod_1.z.string(),
                adyenPaymentSession: zod_1.z
                    .object({
                    sessionData: zod_1.z.string(),
                    id: zod_1.z.string(),
                    adyenPaymentSessionId: zod_1.z.string(),
                })
                    .optional(),
            }),
            400: zod_1.z.object({
                message: zod_1.z.string(),
                reason: zod_1.z
                    .union([
                    zod_1.z.literal('WOULD_EXCEED_SPEND_LIMIT'),
                    zod_1.z.literal('HAS_ACTIVE_SUBSCRIPTION'),
                    zod_1.z.literal('ACCOUNT_SUSPENDED'),
                ])
                    .optional(),
            }),
        },
        body: zod_1.z.object({
            drawTypeCode: zod_1.z.string(),
            drawSchedulePlans: zod_1.z
                .object({
                drawScheduleId: zod_1.z.number(),
                drawTypePlanCode: zod_1.z.string(),
                drawTypePlanSubcode: zod_1.z.string(),
            })
                .array(),
            entries: zod_1.z.array(dbJsonModels_1.ZEntryLine),
            expectedCost: zod_1.z.number(),
            promoCode: zod_1.z.optional(zod_1.z.string()),
            isUpgrade: zod_1.z.optional(zod_1.z.boolean()).default(false),
            referralId: zod_1.z.optional(zod_1.z.string()),
            utmParams: zod_1.z.optional(zod_1.z.record(zod_1.z.string(), zod_1.z.string())).nullable(),
            attributionParams: zod_1.z
                .optional(zod_1.z.record(zod_1.z.string(), zod_1.z.string()))
                .nullable(),
            sourceFor3DS: zod_1.z.string(),
            evalData: dbJsonModels_1.ZPromoConditions.partial().optional(),
        }),
    },
    updateSubscription: {
        method: 'PATCH',
        path: '/:subscription_id',
        body: zod_1.z.object({
            drawSchedulePlans: zod_1.z
                .object({
                drawScheduleId: zod_1.z.number(),
                drawTypePlanCode: zod_1.z.string(),
                drawTypePlanSubcode: zod_1.z.string(),
            })
                .array()
                .optional(),
            entries: zod_1.z.array(dbJsonModels_1.ZEntryLine).optional(),
            expectedCost: zod_1.z.number(),
            version: zod_1.z.number(),
        }),
        responses: {
            200: utils_1.successSchema,
            400: zod_1.z.object({
                message: zod_1.z.string(),
                reason: zod_1.z.literal('WOULD_EXCEED_SPEND_LIMIT').optional(),
            }),
        },
    },
    cancelSubscription: {
        method: 'POST',
        path: '/:subscription_id/cancel',
        pathParams: zod_1.z.object({
            subscription_id: zod_1.z.string(),
        }),
        body: zod_1.z.object({
            cancellationReason: zod_1.z.string().optional(),
        }),
        responses: {
            200: utils_1.successSchema,
            400: c.type(),
        },
    },
    snoozeSubscription: {
        method: 'POST',
        path: '/:subscription_id/snooze',
        pathParams: zod_1.z.object({
            subscription_id: zod_1.z.string(),
        }),
        body: zod_1.z.object({
            snoozeDuration: zod_1.z.number(),
            snoozeUnits: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                snoozedUntil: zod_1.z.coerce.date(),
            }),
            400: c.type(),
        },
    },
    resumeSubscription: {
        method: 'POST',
        path: '/:subscription_id/resume',
        pathParams: zod_1.z.object({
            subscription_id: zod_1.z.string(),
        }),
        body: zod_1.z.object({}),
        responses: {
            200: utils_1.successSchema,
            400: c.type(),
        },
    },
    getSubscriptionHistory: {
        method: 'GET',
        path: '/:subscription_id/history',
        pathParams: zod_1.z.object({
            subscription_id: zod_1.z.string(),
        }),
        responses: {
            200: models_4.ZSubscriptionHistorySelect.array(),
            404: c.type(),
        },
    },
    createChangePaymentMethodSession: {
        method: 'POST',
        path: '/:subscription_id/change-payment-method',
        pathParams: zod_1.z.object({
            subscription_id: zod_1.z.string(),
        }),
        body: zod_1.z.object({}),
        responses: {
            200: zod_1.z.object({
                adyenPaymentSession: zod_1.z.object({
                    sessionData: zod_1.z.string(),
                    id: zod_1.z.string(),
                    adyenPaymentSessionId: zod_1.z.string(),
                }),
                willBeChargedImmediately: zod_1.z.boolean(),
            }),
            400: c.type(),
        },
    },
    getPlayerSubscriptions: {
        method: 'GET',
        path: '/player',
        responses: {
            200: zod_1.z.array(zod_1.z.object({
                order: models_2.ZOrderSelect,
                drawOrder: models_1.ZDrawOrderSelect,
                subscription: models_4.ZSubscriptionSelect,
                drawSchedulePlans: zod_1.z
                    .object({
                    drawSchedule: draw_1.ZDrawScheduleSelect,
                    drawTypePlan: draw_1.ZDrawTypePlanSelect,
                })
                    .array(),
                drawType: draw_1.ZDrawTypeSelect,
                promoCodeRecurring: zod_1.z.optional(models_3.ZPromoCodeRecurringSelect),
                promoCode: zod_1.z.optional(models_3.ZPromoCodeSelect),
            })),
        },
    },
}, {
    pathPrefix: '/auth',
    strictStatusCodes: true,
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
});
//# sourceMappingURL=subscription.auth.contract.js.map